import { ListPageHeader } from 'common';
import ScrollToTop from 'components/UI/ScrollToTop';
import { ProductContext, URLControlledFilterableCategoryProductGrid } from 'product';
import React from 'react';
import './ProductListPage.scss';
function ProductListPage({ heading, products, filterCategories, preSelectedCategory, preSelectedSubCategory, }) {
    const categoryContext = preSelectedCategory ? '_' + preSelectedCategory.name : '';
    const subCategoryContext = preSelectedSubCategory ? '_' + preSelectedSubCategory.name : '';
    return (React.createElement("div", { className: "product-list-page" },
        React.createElement(ProductContext.Provider, { value: { context: 'ProductListPage' + categoryContext + subCategoryContext } },
            React.createElement(ScrollToTop, null),
            React.createElement(ListPageHeader, null, heading),
            React.createElement(URLControlledFilterableCategoryProductGrid, { products: products, categories: filterCategories, preSelectedCategory: preSelectedCategory, preSelectedSubCategory: preSelectedSubCategory, allowSort: true, showSubscriptionSwitch: true, showCount: true }))));
}
export default ProductListPage;
